// Generated by ts-to-zod
import { z } from 'zod';
import { answerSchema } from '../models/answer.schema';

export const surveyPatchPayloadSchema = z.object({
  additionalData: z.record(z.unknown()).optional(),
  answers: z.array(answerSchema.omit({ question: true })).optional(),
});
